import { render, staticRenderFns } from "./BrokerOwnerForm.vue?vue&type=template&id=4a5668b8&"
import script from "./BrokerOwnerForm.vue?vue&type=script&lang=js&"
export * from "./BrokerOwnerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports